import { Grid, Typography, makeStyles } from '@material-ui/core';
import { regularCoverages } from 'data-layer-cr/dist/functions/coverages';
import {
  coverageForCode,
  getRegularCoveragesForUnit,
} from 'data-layer-cr/dist/functions/quotations';
import {
  CoverageCatalog,
  CoverageCatalogResume,
  Quotation,
  QuotationUnit,
} from 'data-layer-cr/dist/models';
import { colors, moneyFormat } from 'design-system';
import { useMemo } from 'react';
import InformationCardLayout from './InformationCardLayout';

const { formatMoney } = moneyFormat;

const useStyle = makeStyles(() => ({
  descriptionText: {
    color: colors.abbey,
    fontSize: 15,
    fontWeight: 400,
    marginBottom: 7,
  },
  valueText: {
    fontSize: 23,
    fontWeight: 900,
    marginBottom: 24,
  },
  container: {
    marginTop: 25,
  },
}));

type CoverageDetail = {
  code: string;
  name: string;
  value: string;
};

type Props = {
  quotation: Quotation;
  unit: QuotationUnit;
  coverageCatalogs: CoverageCatalog[];
  coverageCatalogResumes: CoverageCatalogResume[];
};

const CoveragesInformationCard = ({
  quotation,
  unit,
  coverageCatalogs,
  coverageCatalogResumes,
}: Props): JSX.Element => {
  const classes = useStyle();
  const coveragesResume = useMemo((): CoverageDetail[] => {
    const resume: CoverageDetail[] = [];
    const usedCoverages = getRegularCoveragesForUnit(
      unit,
      coverageCatalogResumes,
    );
    regularCoverages(coverageCatalogs).forEach((coverage) => {
      const coverageData = coverageForCode(usedCoverages, coverage.code);
      if (coverageData) {
        resume.push({
          code: coverage.code,
          name: coverage.name,
          value: formatMoney(
            coverageData.insuredValue,
            false,
            quotation.quotationProfile.typeOfMoney,
          ),
        });
      }
    });
    return resume;
  }, [coverageCatalogResumes, coverageCatalogs, quotation, unit]);
  return (
    <InformationCardLayout
      iconSrc="svg/coverage_shield.svg"
      iconAlt="coverage_shield_icon"
      title="Coberturas"
      data-testid="coverages-information-card"
    >
      <Grid container className={classes.container}>
        {coveragesResume.map((coverage) => (
          <Grid
            item
            xs={12}
            key={coverage.code}
            data-testid={`coverages-${coverage.code}`}
          >
            <Typography className={classes.descriptionText}>
              {coverage.name}
            </Typography>
            <Typography className={classes.valueText}>
              {coverage.value}
            </Typography>
          </Grid>
        ))}
      </Grid>
    </InformationCardLayout>
  );
};

export default CoveragesInformationCard;
